/** A palm strike (fx 'palm'): the palm pushed out and rings of force on the target. */
import { registerFx } from './registry';

registerFx('palm', (host) => ({
  skill: ({ src, tgt, tx, ty }) => {
    host.swingArc(src, 'palm', '255,230,190');
    host.fx.push({ type: 'ring', x: tx, y: ty, t: 0, life: 0.3, r: 18, col: '255,230,190' });
    host.fx.push({ type: 'ring', x: tx, y: ty, t: 0, life: 0.45, r: 28, col: '255,210,150' });
    host.burst(tx, ty - 12 * host.tall(tgt), 10, ['#fff2d8', '#ffd7a0'], 60, 10, 0.35);
    host.sfx.swing();
  },
}));
